import React from 'react';
import { useTranslation } from '../App';

const Quote = () => {
  const t = useTranslation();
  return (
    <section className="title">
      <div className="title-cont">
        <h1>"{t.quote.text}"</h1>
      </div>
    </section>
  );
};

export default Quote;